export default __webpack_public_path__ + "static/pattern1-147d533946c1978684d11d0bbf569f37.svg";